<template>
  <div class="main">
    <ball></ball>
    <div class="nav">
      <Nav title="报告详情" :fixed="true"></Nav>
      <div class="top"></div>
    </div>
    <div class="imageBox">
      <div class="imgItem" v-for="(item, index) in reportData" :key="index">
        <img :src="imgSrc + item.reportImage" />
      </div>
    </div>
    <div class="btn">
      <van-button size="large" type="info" @click="downloadIamge()"
        >下载报告</van-button
      >
    </div>
  </div>
</template>

<script>
import Nav from "../../../components/nav.vue";
import { Dialog } from "vant";
export default {
  name: "hospitalExamineDetail",
  components: {
    Nav,
  },
  data() {
    return {
      imgSrc: "data:image/jpeg;base64,",
      reportData: [],
      reqData: {
        clinicId: "",
      },
      name: "",
      termName: "",
    };
  },
  created() {
    this.reqData.clinicId = this.$route.query.clinicId;
    this.name = this.$route.query.name;
    this.termName = this.$route.query.termName;
  },
  mounted() {
    this.getReport();
  },
  methods: {
    async getReport() {
      // console.log(this.method_depy_type)
      try {
        let reqData = this.reqData;
        this.$showLoad();
        let url = "/report/api/querypacsreportbyclinicid";
        // console.log(R_data)
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          reqData,
          (data) => {
            this.$hideLoad();
            if (data.status == 400) {
              Dialog.alert({
                message: "暂无可查看内容",
              }).then(() => {
                this.$router.go(-1)
              });
            }
            this.reportData = data.data.data.data;
          }
        );
      } catch (error) {
        // console.log(error);
        this.$hideLoad();
      }
    },
    downloadIamge() {
      let a = document.createElement("a"); // 生成一个a元素
      let event = new MouseEvent("click"); // 创建一个单击事件
      this.reportData.forEach((item, index) => {
        a.download = this.name + this.termName + "报告单"; // 设置图片名称
        a.href = "data:image/jpeg;base64," + item.reportImage; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  width: 100%;
  position: relative;
  .nav {
    height: 8vh;
  }
  .imageBox {
    width: 100%;
    .imgItem {
      width: 375px;
      margin: 0 auto;
      img {
        width: 375px;
        height: 100%;
      }
    }
  }
  .btn {
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
  }
}
</style>